import { render, staticRenderFns } from "./Manage-Customerdesignation.vue?vue&type=template&id=8e0e61f8"
import script from "./Manage-Customerdesignation.vue?vue&type=script&lang=js"
export * from "./Manage-Customerdesignation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports